import { render, staticRenderFns } from "./performance-guidance-report.vue?vue&type=template&id=a0dd794e"
import script from "./performance-guidance-report.vue?vue&type=script&lang=js"
export * from "./performance-guidance-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports